
let CreateMap = require('@/mixins/CreateMap');
let AutoCompleteAddress = require('@/mixins/AutoCompleteAddress');

module.exports = {

    mixins: [CreateMap, AutoCompleteAddress],

    props: {
        project: {
            type: Object,
            required: true,
        },
        selectedGroupIds: {
            type: Array,
            required: true,
        },
        energyCodes: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            mapZoom: 10,
            groups: [],
            form: null,
        }
    },

    created() {
        this.form = new Form(this.parseFormData()).dontClear()
        this.loadFormVersions();
    },

    mounted() {
        App.bus.$on('google-maps-ready', () => {
            if (this.project.is_started) {
                this.initAddress(this.project.full_address)
            }
        })
    },

    methods: {

        save() {
            this.form.post(`/projects/${this.project.slug}/settings`).then(response => {
                Alert.withAction(response.message).then(() => {
                    this.redirectTo(`/projects/${this.project.slug}`)
                })
            }).catch(errors => {
                console.log(errors)
                Alert.error(errors.first())
            })
        },

        updateForms() {
            this.form.groups = [];
            this.loadFormVersions();
        },

        loadFormVersions(){
            if(!!this.form.version){
                this.groups = this.energyCodes.find(item => {
                    return item.year == this.form.version;
                }).groups
                return;
            }
            this.groups = [];
        },

        parseFormData() {
            return {
                // Project Info
                version: this.project.version,
                name: this.project.name,
                construction_type: this.project.construction_type,
                enforcement_agency: this.project.enforcement_agency,
                phone: this.project.phone,
                // Permit Number
                permit_number: this.project.permit_number,
                permit_issued_at: this.project.permit_issued_at,
                permit_file_uploaded_at: this.project.permit_file_uploaded_at,

                // Address
                address: this.project.address,
                city: this.project.city,
                zip: this.project.zip,
                state_id: this.project.state_id,
                county_id: this.project.county_id,
                country: this.project.country,

                // Project Dates
                started_at: this.project.started_at,
                // Acceptance Forms
                groups: this.selectedGroupIds,
                manufactures: this.project.manufactures
            }
        },

        setAddressFromPlace(place) {

            for (var key in this.addressParts) {
                this.form[this.addressParts[key].to] = '';
            }

            for (var i = 0; i < place.address_components.length; i++) {

                var addressType = place.address_components[i].types[0];

                if (this.addressParts[addressType]) {
                    var val = (this.addressParts[addressType].join + place.address_components[i][this.addressParts[addressType].key]);
                    this.form[this.addressParts[addressType].to] += val;
                }
            }

            var state = this.form.state_id;
            var county = this.form.county_id;

            App.bus.$emit('change-state-and-county', {
                state: state,
                county: county,
            })
        }
    },

    watch:{
        'form.version'(value, oldValue){
            if(oldValue !== undefined){
                this.form.groups = []
            }
        }
    }
}
